import { Injectable } from '@angular/core';
import { RequestService } from './requestService';

import { environment } from '../../../environments/environment';
import { Message } from '../classes/message';

@Injectable()
export class UnitRoomService {
  private _apiEndpoint = environment.apiUrl + 'chats/'; // URL to web api

  constructor(private _requestService: RequestService) {}

  public postMessage(message) {
    return this._requestService.request<Message>(
      'POST',
      this._apiEndpoint + 'unit-room/' + message.unit_room + '/',
      '',
      message
    );
  }
}
